import { Theme } from 'component-library/__styling/themes'
import { breakpoint, breakpointMax } from 'component-library/__styling/style-functions'
import { themedValue } from 'component-library/__styling/themed-value'
import { Breakpoints } from './settings/breakpoints'

/*
Used to return the particular breakpoint for the provided theme, defaults to breakpoint, can substitute breakpointMax

Usage:

const value = themedBreakpoint(theme, { perthnow, thewest, sevennews, fallback}, breakpointFn)
*/

interface ThemedTargetPropsPartialWithFallback {
    perthnow?: keyof Breakpoints
    thewest?: keyof Breakpoints
    sevennews?: keyof Breakpoints
    /* fallback is used to return a value if any of the theme items are undefined */
    fallback: keyof Breakpoints
}

interface ThemedTargetPropsFull {
    perthnow: keyof Breakpoints
    thewest: keyof Breakpoints
    sevennews: keyof Breakpoints
}

export type Props = ThemedTargetPropsPartialWithFallback | ThemedTargetPropsFull

export const themedBreakpoint = (
    theme: Theme,
    themedBreakpointTargets: Props,
    breakpointFn: (point: keyof Breakpoints) => string = breakpoint
) => {
    return breakpointFn(themedValue(theme, themedBreakpointTargets)!)
}

export const themedBreakpointMax = (theme: Theme, themedBreakpointTargets: Props) =>
    themedBreakpoint(theme, themedBreakpointTargets, breakpointMax)
